import { Box, chakra, Flex, Image, shouldForwardProp } from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import React from "react";
import { useTranslation } from "react-i18next";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import useWebsiteInfo from "../../hook/useWebsiteInfo";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const CommonAlertModal = ({ openModal, setOpenModal, content }) => {
  const { t } = useTranslation();
  const i18n_common = (key, props) => t(`common.${key}`, { ...props });

  const dispatch = useDispatch();
  const isMaintainAlert = useSelector((state) => state.isMaintainAlert);

  const { images } = useWebsiteInfo();

  const handleConfirm = () => {
    setOpenModal(false);
  };

  return (
    openModal && (
      <Flex
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="rgba(0, 0, 0, 0.8)"
        zIndex="99999"
        backdropFilter="blur(2px)"
        justifyContent="center"
        alignItems="center"
      >
        <ChakraBox
          as={Flex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.3 }}
          w="85%"
          maxWidth={"520px"}
          h="auto"
          maxHeight={"480px"}
          position={"relative"}
          bgImage={`url('${COMMON_WEB_PATH}/911TW/hintBG2.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          p={6}
          pt="30px"
        >
          <Flex
            fontSize="24px"
            color="white"
            textAlign="center"
            mt={4}
            bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/hintTitleBG.webp')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            sx={{ width: "-webkit-fill-available" }}
            justifyContent="center"
            alignItems="center"
            position="relative"
          >
            <Image
              src={`${COMMON_WEB_PATH}/FlyDragon/hintWORD.webp`}
              height={{
                base: "50px",
                xl: "60px",
              }}
            />
          </Flex>
          <Box
            position="relative"
            my="15px"
            mb="50px"
            fontSize="30px"
            fontWeight="black"
            color="white"
            textAlign="center"
            sx={{
              background:
                "linear-gradient(180deg, #fff 0%,#fdd26a 60%,  #b07f20 80%,  #b07f20 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              textShadow: "0px 1px 3px rgba(255, 215, 0, 0.4)",
            }}
          >
            {content}
          </Box>

          <Flex
            gap={4}
            mb={4}
            justifyContent="space-between"
            alignItems="center"
          >
            <Flex
              as="button"
              w="165px"
              h="62px"
              bgImage={`url('${images.yesBTN}')`}
              bgPosition="center"
              bgRepeat="no-repeat"
              bgSize="100% 100%"
              justifyContent="center"
              alignItems="center"
              onClick={handleConfirm}
              position="relative"
              zIndex={1}
            >
              {/* <Image
                          src={`${COMMON_WEB_PATH}/FlyDragon/yesWORD.webp`}
                          width="70px"
                          height={{
                            base: "30px",
                            xl: "30px",
                          }}
                        /> */}
            </Flex>
          </Flex>
        </ChakraBox>
      </Flex>
    )
  );
};

export default CommonAlertModal;
